import { useState } from "react";
import { useNavigate } from "react-router";
import { roomPath } from "../paths";
import { slugFromJoinLink } from "./joinLink";
import styles from "./JoinByLink.module.css";

export const JoinByLink = () => {
  const navigate = useNavigate();
  const [link, setLink] = useState("");
  const [error, setError] = useState<string | null>(null);

  return (
    <form
      className={styles.form}
      noValidate
      onSubmit={event => {
        event.preventDefault();
        const slug = slugFromJoinLink(link);
        if (!slug) {
          setError("That doesn't look like a PQChat Rooms link. Check the link you were sent and try again.");
          return;
        }
        void navigate(roomPath(slug));
      }}
    >
      <label className={styles.label} htmlFor="join-link">
        Joining a meeting? Paste the link you were sent.
      </label>
      <div className={styles.row}>
        <input
          id="join-link"
          className="input"
          type="text"
          inputMode="url"
          autoComplete="off"
          spellCheck={false}
          placeholder="Meeting link"
          value={link}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? "join-link-error" : undefined}
          onChange={event => {
            setLink(event.target.value);
            setError(null);
          }}
        />
        <button type="submit" className="btn btn-secondary" disabled={!link.trim()}>
          Join
        </button>
      </div>
      {error && (
        <p id="join-link-error" className="error-text" role="alert">
          {error}
        </p>
      )}
    </form>
  );
};
